import { Injectable, ComponentRef, Component, ComponentFactoryResolver } from "@angular/core";
import {LoaderDirective} from 'nm-socle-application/app/shared/directives/loader-directive';

@Injectable()
export class ComponentsManagerService {

    private _uiComponentsRef: { [key: string]: any[] };

    /**
     * @constructor
     * @description
     *
     */
    constructor(
        protected componentFactoryResolver: ComponentFactoryResolver,
    ) {
        this._uiComponentsRef = {};
    }

    public addComponentRef(name: string, theClassRef: any) {
        this._uiComponentsRef[name] = theClassRef;
    }

    // TODO responsive : gérer l'absence
    public getComponentRef(name: string): any {
        let theClass: any;

        if (this._uiComponentsRef[name] != undefined) {
            theClass = this._uiComponentsRef[name];
        }

        return theClass;
    }

    public createComponent(prevCompoRef:ComponentRef<Component>, templateType:string, loaderHost:LoaderDirective):ComponentRef<Component> {
        let compoRef:ComponentRef<Component>;

        if(prevCompoRef != undefined) {
            prevCompoRef.destroy();
        }

        let compoClass:any = this.getComponentRef(templateType);

        if(compoClass != undefined) {
            let componentFactory = this.componentFactoryResolver.resolveComponentFactory(compoClass);

            compoRef = loaderHost.viewContainerRef.createComponent(componentFactory);
        }

        return compoRef;
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/shared/services/component-manager.service.ts